import { createFileRoute } from "@tanstack/react-router";
import { CityPicker } from "@/components/CityPicker";
import { SITE_URL } from "@/lib/seo";

export const Route = createFileRoute("/pakistan/silver-cities")({
  head: () => ({
    meta: [
      { title: "Silver Rate by City — Pakistan | DrHint" },
      { name: "description", content: "Choose your city to see today's live silver (chandi) rate in Pakistan — Karachi, Lahore, Islamabad and more." },
      { property: "og:title", content: "Silver Rate by City — Pakistan" },
      { property: "og:description", content: "Pick your city and see live silver prices, charts, and full breakdown." },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/pakistan/silver-cities` }],
  }),
  component: () => <CityPicker country="pakistan" metal="silver" />,
});